import React, { useState, useEffect, useRef } from 'react';

import axios from 'axios';
import swal from 'sweetalert';
import { Link, Redirect } from 'react-router-dom'
import moment from 'moment';
import MUIDataTable from "mui-datatables";

import SetColor from './SetColor.js';
import { Modal } from 'react-bootstrap';
import { setCookie, getCookie } from '../common_component/cookie.js';
import Organization_modal from '../common_component/organization_modal.js';
import Timer_modal from '../common_component/timer_modal.js';
import Select from 'react-select';
import product_unit_arr from './common_arr/product-unit-arr.js';


//import "antd/dist/antd.css";
import { Drawer, Button, Space } from 'antd';

export const ItemPriceList = () => {
    const timer_interval_ref = useRef();
    const [clockTimerModalShow, setClockTimerModalShow] = useState(false);
    const [state_org, setstate_org] = useState(2);
    const [organization_name, setOrganization_name] = useState("");
    const [OrganizationModalShow, setOrganizationModalShow] = useState(false);
    const [redirect_to_login, setRedirect_to_login] = useState(2);

    const [Branch_name, setBranch_name] = useState("All");
    const [Warehouse_name, setWarehouse_name] = useState("All");
    const [Branchlist, setBranchlist] = useState([]);
    const [WarehouseSelectionList, setWarehouseSelectionList] = useState([]);
    const [open, setOpen] = useState(false);
    const [childrenDrawer, setChildrenDrawer] = useState(false);
    const [navtype, setnavtype] = useState("Overview");
    const [UnitSelectionList, setUnitSelectionList] = useState([]);
    const [Specification_info, setSpecification_info] = useState({ "MPN": "", "ICBN": "", "UPC": "", "EAN": "" });
    const [toTopButtonDisplay, setToTopButtonDisplay] = useState(false)

    const [user, setUser] = useState({});
    const [state, setstate] = useState(2);
    const [userTheme, setUserTheme] = useState((localStorage.getItem("kt_metronic_theme_mode_menu") == "system") ? window.matchMedia("(prefers-color-scheme: dark)").matches ? "dark" : "light" : localStorage.getItem("kt_metronic_theme_mode_menu"))
    const timer = useRef(0)
    const [clock_timer, setClockTimer] = useState(0);


    const [data, setData] = useState([]);
    const [editmodal, setEditModal] = useState([]);
    const [listCount, setListCount] = useState(0)
    const [currentPage, setCurrentPage] = useState(0)
    const [rowsPerPage, setRowsPerPage] = useState(10)
    const [sortColumn, setSortColumn] = useState(null)
    const [sortValue, setSortValue] = useState(null)
    const [searchValue, setSearchValue] = useState(null)
    const [itemsListApiState, setItemsListApiState] = useState(false);


    const [tag_name, settag_name] = useState("");
    const [productid, setproductid] = useState("");
    const [status, setstatus] = useState("");


    const [visibility, setvisibility] = useState(0);
    const [redirect, setredirect] = useState(0);
    const [organization_id, setOrganization_id] = useState("");
    const [organization_list, setorganization_list] = useState([]);
    const [read, setread] = useState(2);
    const [write, setwrite] = useState(2);
    const [mainSubmitButtonState, setMainSubmitButtonState] = useState(false);
    const [Warehouselist, setWarehouselist] = useState([]);

    const [StatusModalShow, setStatusModalShow] = useState(false);
    const [Item_name, setItem_name] = useState("");
    const [Item_flag, setItem_flag] = useState(0);
    const [Pricedetails, setPricedetails] = useState([]);
    const [Item_details, setItem_details] = useState([]);
    const [Tax_details, setTax_details] = useState([]);
    const [Stock_history_details, setStock_history_details] = useState([]);
    const [Selected_Stock_history_details, setSelected_Stock_history_details] = useState([]);
    const [Item_history_details, setItem_history_details] = useState([]);
    const [Serial_batch_details, setSerial_batch_details] = useState([]);
    const [Selected_serial_batch_details, setSelected_serial_batch_details] = useState([]);

    const [ecommerceModalShow, setEcommerceModalShow] = useState(false)
    const [ecommerceProductInfoApiState, setEcommerceProductInfoApiState] = useState(false)
    const [selectedEcommerceProductId, setSelectedEcommerceProductId] = useState(null)
    const [ecommb2b, setEcommb2b] = useState(false)
    const [ecommb2c, setEcommb2c] = useState(false)
    const [ecommerceModalSubmitButtonState, setEcommerceModalSubmitButtonState] = useState(false)

    const [Currency_symbol, setCurrency_symbol] = useState("");
    const [Decimal_place, setDecimal_place] = useState();

    function hasSpecialSymbol(word) {
        // Create a regular expression that matches the special symbol #.
        const specialCharacter = '%';
        const specialCharacters = new RegExp(`(${specialCharacter})`, 'g');

        // Return true if the word contains the special symbol #.
        return specialCharacters.test(word);
    }

    var page_name = "item-price-list";

    const loaderstyle = {
        display: "block",
        marginLeft: "auto",
        marginRight: "auto",
        marginTop: "auto",
        marginBottom: "auto",
    };

    const onRowClick = async (rowData, rowMeta) => {
        //setOpen(true);
        window.scrollTo({ top: document.body.scrollHeight, behavior: 'smooth' });
        var object = {};
        object.email = user.email;
        getItemPriceInforrmation(rowData[0]);
    }

    function upperInteger(number) {
        // Get the next highest integer.
        const nextInteger = Math.ceil(number);

        // If the next highest integer is a decimal, round it up to the nearest integer.
        if (nextInteger % 1 !== 0) {
            nextInteger = Math.round(nextInteger);
        }

        // Return the next highest integer.
        return nextInteger;
    }

    function getAvailableValues(array, start, end) {
        // Check if the array is empty.
        if (array.length === 0) {
            return [];
        }

        // Check if start index is valid.
        if (start < 0 || start >= array.length) {
            start = 0;
        }

        // Check if end index is valid.
        if (end < 0 || end >= array.length) {
            end = array.length - 1;
        }

        // Get the values from start index to end index.
        const availableValues = array.slice(start, end + 1);

        // Check if all values are available.
        if (availableValues.every(value => value !== undefined)) {
            // Return the values.
            return availableValues;
        }

        // No values are available.
        return [];
    }

    async function getItemPriceInforrmation(id) {
        var object = {};
        object.email = user.email;
        setItem_flag(2);
        const response = await fetch(
            `${process.env.REACT_APP_SERVER_URL}/get-product-price-info`, { method: 'POST', body: JSON.stringify({ "id": id, "flag": "list", "email": user.email, "page_name": page_name, "organization_id": organization_id }), headers: { "Content-type": "application/json; charset=UTF-8", "token": getCookie("access_token") } }
        );
        const body = await response.json();
        var temp_dropdown = [];
        if (body.operation === "success") {
            let price_arr = body.price_details;
            let temp = upperInteger(price_arr.length / 4);
            let color_code = ["info", "danger", "success", "warning", "primary", "info", "danger", "success"]
            let arr = [];
            let start_index = 0;
            let occupied_length = 0;
            for (let i = 0; i < temp; i++) {
                let obj = {};
                obj.color = color_code[i];
                if ((price_arr.length - occupied_length) >= 4) {
                    const nextFourValues = price_arr.slice(start_index, start_index + 4);
                    occupied_length += nextFourValues.length;
                    obj.price_details = nextFourValues;
                    arr.push(obj);
                    start_index = start_index + 3;
                    // Add the values to the destination array.
                }
                else {
                    // There are not enough values.
                    const remainingValues = price_arr.slice(-(price_arr.length - occupied_length));
                    occupied_length += remainingValues.length;
                    obj.price_details = remainingValues;
                    arr.push(obj);
                    break;
                    // Add the remaining values to the destination array.
                }
            }
            setPricedetails(arr);
            setTax_details(body.tax_details)
            setItem_flag(1);
        }
        else {
            setItem_flag(4);
        }
    }

    async function getbasecurrency() {
        var object = {};
        object.email = user.email;

        const response = await fetch(
            `${process.env.REACT_APP_SERVER_URL}/get-base-currency`, { method: 'POST', body: JSON.stringify({ "email": user.email, "page_name": page_name, "organization_id": organization_id }), headers: { "Content-type": "application/json; charset=UTF-8", "token": getCookie("access_token") } }
        );
        const body = await response.json();
        // console.log(body.data)

        if (body.length > 0) {
            setCurrency_symbol(body[0].currency_symbol);
            setDecimal_place(parseInt(body[0].decimal_place))
        }
    }

    const showDrawer = () => {
        setOpen(true);
    };

    const onClose = () => {
        setOpen(false);
    };

    const showChildrenDrawer = (val) => {
        console.log(Stock_history_details);
        console.log(val);
        if (Item_details[0].tracking_inventory_type === "Track Serial Number") {
            setSelected_Stock_history_details(Stock_history_details.filter(option => option.serialName == val));
        }
        else {
            setSelected_Stock_history_details(Stock_history_details.filter(option => option.Batch_Reference == val));
        }
        //setSelected_Stock_history_details(Stock_history_details.filter(option => option.Batch_Reference == val))
        settag_name(val);
        setChildrenDrawer(true);
    };

    const onChildrenDrawerClose = () => {
        setChildrenDrawer(false);
    };

    const options = {
        filter: true,
        selectableRows: "none",
        fixedHeader: false,
        onRowClick: onRowClick,
        responsive: "standard",
        tableBodyHeight: "480px",
        tableBodyMaxHeight: "",
    };

    let dropdownStyleDark = {
        option: (provided, state) => ({
            ...provided,
            color: '#dddddf',
            backgroundColor: state.isSelected ? provided.backgroundColor : state.isFocused ? '#5f5f8d' : provided.backgroundColor,
        }),
        control: (provided, state) => ({
            ...provided,
            backgroundColor: "#2b2b40",
            borderColor: "#4c4c71"
        }),
        placeholder: (provided, state) => ({
            ...provided,
            color: "#dddddf",
        }),
        singleValue: (provided, state) => ({
            ...provided,
            color: "#dddddf",
        }),
        menu: (provided, state) => ({
            ...provided,
            backgroundColor: "#2b2b40",
        })
    }

    const columns = [
        {
            name: "product_id",
            label: "product_id",
            options: {
                display: false,
                filter: true,
                sort: true
            }
        },
        {
            name: "product_name",
            label: "Item Name",
            options: {
                filter: true,
                sort: true
            }
        },
        {
            name: "product_type",
            label: "Tracking Inventory Type",
            options: {
                filter: true,
                sort: true
            }
        },
        {
            name: "category_name",
            label: "Category ",
            options: {
                filter: true,
                sort: true
            }
        },
        {
            name: "subcategory_name",
            label: "SubCategory ",
            options: {
                filter: true,
                sort: true
            }
        },
        {
            name: "add_status",
            label: "Status",
            options: {
                filter: true,
                sort: true,
                customBodyRender: (value, tableMeta, updateValue) => {
                    return (
                        <SetColor
                            value={value}
                            index={tableMeta.columnIndex}
                            change={event => updateValue(event)}
                        />
                    )
                }
            }
        },
        {
            name: "actions",
            label: "Actions",
            options: {
                filter: false,
                sort: false,
                download: false
            }
        }
    ];

    useEffect(() => {
        if (getCookie("access_token") != "") {
            if (getCookie("organization_id") != "") {
                setOrganization_id(getCookie("organization_id"));
            }
            else {
                var object = {};
                object.page_name = page_name;
                var headers = {
                    headers: {
                        "Content-Type": "application/json",
                        "token": getCookie("access_token"),
                        "Accept": "*/*"
                    }
                }

                axios.post(`${process.env.REACT_APP_SERVER_URL}/show-organization`, object, headers).then((res) => {
                    if (res.data.length == 1) {
                        setCookie('organization_id', res.data[0].organization_id, 1, true);
                        setOrganization_id(res.data[0].organization_id)
                    }
                    else {
                        setstate_org(1);
                        setorganization_list(res.data);
                        setOrganizationModalShow(true);
                    }
                })
            }
        }
        else {
            setRedirect_to_login(1);
        }
    }, [])

    useEffect(() => {
        setCookie("lastpage", window.location.href, 1, false)
        const validateJWT = () => {

            if (getCookie("access_token") != "") {
                var object = {};
                object.token = getCookie("access_token");

                var headers = {
                    headers: {
                        "Content-Type": "application/json",
                        "Accept": "*/*"
                    }
                }
                axios.post(`${process.env.REACT_APP_SERVER_URL}/get-user`, object, headers).then((res) => {

                    if (res.data.operation == "success") {
                        var user_object = {};
                        user_object.email = res.data.email;
                        user_object.name = res.data.name;
                        user_object.img = res.data.img;

                        setUser(user_object)
                    }
                    else {
                        swal("Session Expired!", "Please login to continue using.", "warning").then((value) => {
                            window.location.href = "/login"
                        });
                    }
                })
                    .catch(function (error) {
                        swal("Session Expired!", "Please login to continue using.", "warning").then((value) => { window.location.href = "/login" });
                    });
                object.organization_id = organization_id;
                axios.post(`${process.env.REACT_APP_SERVER_URL}/audience-info`, object, headers).then((res) => {

                    if (res.data.operation == "success") {
                        var token = res.data.audience_license;
                        if (res.data.organization_flag == 0) {
                            setstate_org(3);
                            setOrganization_name(res.data.organization_name);
                            setOrganizationModalShow(true);
                        }
                        else {
                            var path = window.location.pathname;
                            path = path.replace(/\/$/, "");
                            path = decodeURIComponent(path);
                            var original_url = path.split("/")[1]
                            let index = 0;
                            let temp = -1;
                            for (let i = 0; i < res.data.user_access.access.length; i++) {
                                if (temp == 1) break;
                                let component = res.data.user_access.access[i].inside_components;
                                for (let j = 0; j < component.length; j++) {
                                    if (temp == 1) break;
                                    if (component[j].hasOwnProperty(original_url)) {
                                        index = i;
                                        if (component[j][original_url] == 1 && res.data.user_access.access[index].visibility == 1) {
                                            temp = 1;
                                            setvisibility(1);
                                            setread(component[j]["read"])
                                            setwrite(component[j]["write"])
                                            // setwrite(0)
                                            // break;
                                        }
                                        else {
                                            setredirect(1);
                                        }
                                    }
                                    else if (component[j].hasOwnProperty("key")) {
                                        let sub_inside_components = component[j].inside_components
                                        for (let k = 0; k < sub_inside_components.length; k++) {
                                            if (sub_inside_components[k].hasOwnProperty(original_url)) {
                                                index = i
                                                if (sub_inside_components[k][original_url] == 1 && res.data.user_access.access[index].visibility == 1 && component[j].visibility == 1) {
                                                    temp = 1;
                                                    setvisibility(1);
                                                    setread(sub_inside_components[k]["read"])
                                                    setwrite(sub_inside_components[k]["write"])
                                                    // setwrite(0)
                                                    break;

                                                }
                                                else {
                                                    setredirect(1);
                                                }
                                            }
                                        }
                                    }
                                    else {
                                        temp = 2;
                                    }
                                }
                            }

                            if (temp == 2) {
                                setredirect(1);
                            }

                        }
                        if (!token.includes("ufhdsupw29fher") || !token.includes("pdbwu27dh6schs") || !token.includes("0dh27agiqbcrwi")) {
                            setCookie('access_token', res.data.audience_license, 1, true)
                            timer.current = process.env.REACT_APP_JWT_EXPIRY;
                            //setClockTimer(process.env.REACT_APP_JWT_EXPIRY);
                        }
                        else {
                            timer.current = res.data.audience_count;
                            //setClockTimer(res.data.audience_count)
                        }
                    }
                    else {
                        setRedirect_to_login(1);
                    }
                })
                    .catch(function (error) {
                        setRedirect_to_login(1);
                    });
            }
            else {
                setRedirect_to_login(1);
            }
        }
        organization_id != "" && validateJWT();
    }, [organization_id])

    useEffect(() => {
        const scrollFunc = () => {
            if (document.body.scrollTop > 20 || document.documentElement.scrollTop > 20) {
                setToTopButtonDisplay(true)
            }
            else {
                setToTopButtonDisplay(false)
            }
        }

        window.addEventListener("scroll", scrollFunc)

        return () => { window.removeEventListener("scroll", scrollFunc) }
    }, [])

    useEffect(() => {
        var obj_array = [];
        var Productunitarr = product_unit_arr.product_unit_arr;
        //console.log(Productunitarr)
        setUnitSelectionList(Productunitarr);
    }, []);

    useEffect(() => {
        let id = setInterval(() => {
            setUserTheme((localStorage.getItem("kt_metronic_theme_mode_menu") === "system") ? (window.matchMedia("(prefers-color-scheme: dark)").matches ? "dark" : "light") : (localStorage.getItem("kt_metronic_theme_mode_menu") || "light"));
            // setUserTheme((localStorage.getItem("kt_metronic_theme_mode_menu") == "system") ? window.matchMedia("(prefers-color-scheme: dark)").matches ? "dark" : "light" : localStorage.getItem("kt_metronic_theme_mode_menu"))
        }, 10)

        return () => {
            clearInterval(id)
        }
    }, [])

    useEffect(() => {
        timer_interval_ref.current = setInterval(() => {
            // console.log(timer)

            timer.current = timer.current - 1
            if (timer.current > 0 && timer.current < process.env.REACT_APP_JWT_EXPIRY_NOTICE) {
                if (!clockTimerModalShow) {
                    setClockTimer(process.env.REACT_APP_JWT_EXPIRY_NOTICE)
                    setClockTimerModalShow(true)
                }
            }
        }, 1000);

        return () => { clearInterval(timer_interval_ref) };
    }, []);


    async function getitemdetails(cp, rpp, sort_c, sort_v, search_v) {
        var object = {};
        object.email = user.email;
        setItemsListApiState(true);
        const response = await fetch(
            `${process.env.REACT_APP_SERVER_URL}/product-datatable`, { method: 'POST', body: JSON.stringify({ "email": user.email, "organization_id": organization_id, "current_page": cp, "rows_per_page": rpp, "sort_column": sort_c, "sort_value": sort_v, "search_value": search_v, "page_name": page_name }), headers: { "Content-type": "application/json; charset=UTF-8", "token": getCookie("access_token") } }
        );
        const body = await response.json();

        if (body.data.list.length > 0) {
            setEditModal(body.data.list);
            setListCount(body.data.count);
            setItemsListApiState(false);
        }
        else {
            setstate(1);
            setData([]);
        }
    }

    async function getbranchdetails() {
        var object = {};
        object.email = user.email;

        const response = await fetch(
            `${process.env.REACT_APP_SERVER_URL}/get-branches`, { method: 'POST', body: JSON.stringify({ "email": user.email, "page_name": page_name, "organization_id": organization_id }), headers: { "Content-type": "application/json; charset=UTF-8", "token": getCookie("access_token") } }
        );
        const body = await response.json();
        var temp_dropdown = [];
        if (body.operation == "success") {
            if (body.data.length > 0) {
                temp_dropdown.push({ label: "All", value: "All" });
                body.data.map((obj) => {
                    var temp_obj = {};
                    temp_obj.label = obj.branch_name;
                    temp_obj.value = obj.branch_id;
                    temp_dropdown.push(temp_obj);
                })
                setBranchlist(temp_dropdown);
            }
        }
    }

    async function getwarehousedetails() {
        var object = {};
        object.email = user.email;

        const response = await fetch(
            `${process.env.REACT_APP_SERVER_URL}/list-warehouse`, { method: 'POST', body: JSON.stringify({ "email": user.email, "page_name": page_name, "organization_id": organization_id }), headers: { "Content-type": "application/json; charset=UTF-8", "token": getCookie("access_token") } }
        );
        const body = await response.json();
        var temp_dropdown = [];
        if (body.operation == "success") {
            if (body.data.length > 0) {
                let temp_dropdown = [];
                temp_dropdown.push({ label: "All", value: "All" });
                setWarehouseSelectionList(temp_dropdown);
                setWarehouselist(body.data);
            }
        }
    }

    async function getProductEcommerceInfo(pid) {
        setEcommerceProductInfoApiState(true)
        const response = await fetch(
            `${process.env.REACT_APP_SERVER_URL}/get-product-ecommerce-info`, { method: 'POST', body: JSON.stringify({ "email": user.email, "product_id": pid, "page_name": page_name, "organization_id": organization_id }), headers: { "Content-type": "application/json; charset=UTF-8", "token": getCookie("access_token") } }
        );
        const body = await response.json();

        if (body.operation == "success") {
            setEcommerceProductInfoApiState(false)
            if (body.data != null) {
                setEcommb2b(body.data.b2b)
                setEcommb2c(body.data.b2c)
            }
        }
    }

    useEffect(() => {
        if ((read || write) && (user.email && visibility)) {

            let p1 = getitemdetails(currentPage, rowsPerPage, sortColumn, sortValue, searchValue);
            let p2 = getbasecurrency();
            //let p3 = getbranchdetails();

            Promise.all([p1, p2])
                .then(() => {
                    setstate(1)
                    console.log("all apis done")
                })
                .catch((err) => {
                    setstate(3)
                    console.log(err)
                })
        }

    }, [user, visibility, read, write])

    useEffect(() => {
        if (state == 1) {
            getitemdetails(currentPage, rowsPerPage, sortColumn, sortValue, searchValue)
        }
    }, [currentPage, rowsPerPage, sortColumn, sortValue, searchValue])

    useEffect(() => {

        var temp_data = [];
        editmodal.map((obj) => {
            var temp_obj = {};
            temp_obj.product_id = obj.pid;
            temp_obj.product_name = obj.product_name;
            temp_obj.product_type = <span className="badge badge-secondary me-auto rounded">{obj.tracking_inventory_type}</span>;
            temp_obj.category_name = obj.category_name;
            temp_obj.subcategory_name = obj.subcategory_name;
            temp_obj.add_status = obj.add_status;
            temp_obj.category_code = obj.category_code;
            temp_obj.id = obj.pid;

            let id = obj.pid;

            temp_obj.actions = <div className="dropdown">
                <button onClick={(e) => { e.stopPropagation() }} className="btn btn-sm btn-secondary rounded" type="button" id="dropdownMenuButton1" data-bs-toggle="dropdown" aria-expanded="false"><i className="fas fa-bars px-0"></i></button>
                {
                    write &&
                    <ul className="dropdown-menu" aria-labelledby="dropdownMenuButton1">
                        <li className="py-1"><Link to={`/edit-item/${id}`} className="dropdown-item">Edit details</Link></li>
                        <li className="py-1"><div className="dropdown-item" style={{ cursor: "pointer" }} onClick={(e) => { e.stopPropagation(); updateStatus(id); setStatusModalShow(true); }} >Change status</div></li>
                        <li className="py-1"><Link to={`/item-price-information/${id}`} className="dropdown-item" >Add/Edit price</Link></li>
                        {obj.track_inventory == "1" && <li className="py-1"><Link to={`/item-stock-information/${id}`} className="dropdown-item">Add/Edit stock</Link></li>}
                        <li className="py-1"><Link to={`/item-images/${id}`} className="dropdown-item">Add/Edit product image</Link></li>
                        <li className="py-1"><div className="dropdown-item" style={{ cursor: "pointer" }} onClick={(e) => { e.stopPropagation(); getProductEcommerceInfo(id); setSelectedEcommerceProductId(id); setEcommerceModalShow(true); }} >Configure product E-commerce info</div></li>
                    </ul>
                }
            </div>
            temp_data.push(temp_obj);
        })
        setData(temp_data);

    }, [editmodal])

    const updateStatus = (id) => {
        for (let i = 0; i < editmodal.length; i++) {
            if (id == editmodal[i].pid) {
                setproductid(id);
                //console.log(editmodal[i].add_status);
                setstatus(editmodal[i].add_status);
            }
        }
    }

    const submitStatus = (e) => {
        e.preventDefault();

        var values = { "id": productid, "status": status, "page_name": page_name, "organization_id": organization_id };
        setMainSubmitButtonState(true)
        var headers = {
            headers: {
                "Content-Type": "application/json",
                "Accept": "*/*",
                "token": getCookie("access_token")
            }
        }

        axios.post(`${process.env.REACT_APP_SERVER_URL}/update-status-product`, values, headers).then((res) => {
            setMainSubmitButtonState(false)
            if (res.data && res.data.operation == "success") {
                swal("Great!", "Status changed successfully!", "success").then((value) => {
                    window.location.reload();
                });
            }
            else {
                swal("Oops!", "Something went wrong!", "error");
            }
        });
    }

    const WarehouseLoad = (value) => {
        let arr = [];
        let temp_dropdown = [];
        if (value === "All") {
            var temp_obj = {};
            temp_obj.label = "All";
            temp_obj.value = "All";
            temp_dropdown.push(temp_obj);

        }
        else {
            //console.log(Warehouselist);
            arr = Warehouselist.filter(option => option.branch_id == value);
            arr.map((obj) => {
                var temp_obj = {};
                temp_obj.label = obj.name;
                temp_obj.value = obj.wid;
                temp_dropdown.push(temp_obj);
            })
        }
        if (temp_dropdown.length > 0) {
            setWarehouseSelectionList(temp_dropdown);
            if (arr.filter(option => option.default == 1).length > 0) {
                setWarehouse_name(arr.filter(option => option.default == 1)[0].wid);
                Serial_batch_filter(value, arr.filter(option => option.default == 1)[0].wid);
            }
            else {
                setWarehouse_name(arr[0].wid);
                Serial_batch_filter(value, arr[0].wid);
            }
        }
        else {
            Serial_batch_filter(value, "");
            setWarehouseSelectionList([]);
            setWarehouse_name("");
        }

    }

    const Serial_batch_filter = (branch_id, warehouse_id) => {
        // console.log(Serial_batch_details);
        // console.log(branch_id);
        // console.log(warehouse_id);
        let arr = [];
        if (warehouse_id === "All" && branch_id === "All") {
            arr = Serial_batch_details;
        }
        else if (warehouse_id === "" && branch_id !== "") {
            arr = Serial_batch_details.filter(option => (option.Branch == branch_id));
        }
        else if (warehouse_id !== "" && branch_id !== "") {
            arr = Serial_batch_details.filter(option => (option.warehouse == warehouse_id && option.Branch == branch_id));
        }
        console.log(arr);
        setSelected_serial_batch_details(arr);
    }

    const configureProductEcommerceInfoSubmit = () => {

        var object = {};

        object.product_id = selectedEcommerceProductId
        object.b2b = ecommb2b
        object.b2c = ecommb2c

        object.organization_id = organization_id;
        object.page_name = page_name;

        console.log(object);
        setEcommerceModalSubmitButtonState(true)

        var headers = {
            headers: {
                "Content-Type": "application/json",
                "Accept": "*/*",
                "token": getCookie("access_token")
            }
        }
        axios.post(`${process.env.REACT_APP_SERVER_URL}/configure-product-ecommerce-info`, object, headers).then((res) => {
            setEcommerceModalSubmitButtonState(false)
            if (res.data.operation === "success") {
                swal("Great!", "Product E-Commerce Info configured successfully!", "success")
                handleEcommerceModalClose()
            }
            else {
                swal("Oops!", res.data.message, "error");
            }
        })
            .catch(function (error) {
                console.log(error)
            });
    }

    const handleEcommerceModalClose = () => {
        setEcommerceModalShow(false)

        setSelectedEcommerceProductId(null)
        setEcommb2b(false)
        setEcommb2c(false)
    }

    const trimDecimalPlaces = (amt, decimal_place) => {
        return Math.round(amt * Math.pow(10, decimal_place)) / Math.pow(10, decimal_place)
    }

    // console.log(editmodal)
    return (
        <>
            {
                (redirect == 1 || (read == 0 && write == 0)) ?
                    <>
                        <Redirect to={{
                            pathname: "/unauthorized",
                        }}
                        />
                    </> :
                    null
            }
            <div className="d-flex flex-column flex-column-fluid">
                <div className="app-toolbar py-3 py-lg-6" id="kt_app_toolbar">
                    <div id="kt_app_toolbar_container" className="app-container container-xxl d-flex flex-stack">
                        <h1 className="page-heading d-flex text-dark fw-bold fs-3 flex-column justify-content-center my-0">Item List
                            <small className="text-muted fs-7 fw-bold my-1 ms-1"></small>
                        </h1>
                        <div className="d-flex align-items-center gap-2 gap-lg-3">
                            <div className="m-0">
                                <Link to={`/add-item`} className="btn btn-sm btn-primary me-3 rounded">
                                    <span className="svg-icon svg-icon-2">
                                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <rect opacity="0.5" x="11" y="18" width="12" height="2" rx="1" transform="rotate(-90 11 18)" fill="currentColor"></rect>
                                            <rect x="6" y="11" width="12" height="2" rx="1" fill="currentColor"></rect>
                                        </svg>
                                    </span>
                                    Create new Item</Link>
                            </div>
                        </div>
                    </div>
                </div>
                <div id="kt_app_content" className="app-content flex-column-fluid">
                    <div id="kt_app_content_container" className="app-container container-xxl">
                        {
                            state == 1 ?
                                <>
                                        <MUIDataTable
                                            title={
                                                <>
                                                    <span className='me-20'>Item List</span>
                                                    {itemsListApiState && <><span>Loading...</span>
                                                        <svg width="50" height="15" viewBox="0 45 100 10">
                                                            <g transform="translate(20 50)"><circle cx="0" cy="0" r="6" fill="#e15b64"><animateTransform attributeName="transform" type="scale" begin="-0.375s" calcMode="spline" keySplines="0.3 0 0.7 1;0.3 0 0.7 1" values="0;1;0" keyTimes="0;0.5;1" dur="1s" repeatCount="indefinite"></animateTransform></circle></g>
                                                            <g transform="translate(40 50)"><circle cx="0" cy="0" r="6" fill="#f8b26a"><animateTransform attributeName="transform" type="scale" begin="-0.25s" calcMode="spline" keySplines="0.3 0 0.7 1;0.3 0 0.7 1" values="0;1;0" keyTimes="0;0.5;1" dur="1s" repeatCount="indefinite"></animateTransform></circle></g>
                                                            <g transform="translate(60 50)"><circle cx="0" cy="0" r="6" fill="#abbd81"><animateTransform attributeName="transform" type="scale" begin="-0.125s" calcMode="spline" keySplines="0.3 0 0.7 1;0.3 0 0.7 1" values="0;1;0" keyTimes="0;0.5;1" dur="1s" repeatCount="indefinite"></animateTransform></circle></g>
                                                            <g transform="translate(80 50)"><circle cx="0" cy="0" r="6" fill="#81a3bd"><animateTransform attributeName="transform" type="scale" begin="0s" calcMode="spline" keySplines="0.3 0 0.7 1;0.3 0 0.7 1" values="0;1;0" keyTimes="0;0.5;1" dur="1s" repeatCount="indefinite"></animateTransform></circle></g>
                                                        </svg>
                                                    </>}
                                                </>
                                            }
                                            data={data}
                                            columns={columns}
                                            options={{
                                                ...options,
                                                download: false,
                                                filter: false,
                                                searchPlaceholder: 'Search Item',
                                                serverSide: true,
                                                count: listCount,
                                                //jumpToPage: true,
                                                onChangePage: (val) => { setCurrentPage(val) },
                                                onChangeRowsPerPage: (val) => { setCurrentPage(0); setRowsPerPage(val) },
                                                onColumnSortChange: (col, dir) => { setSortColumn(col); setSortValue(dir) },
                                                onSearchChange: (val) => { setCurrentPage(0); setSearchValue(val) },
                                                // onTableChange: (action, tableState)=>{console.log(action, tableState);}
                                            }}
                                        />
                                    {Item_flag !== 0 &&
                                        <div className="card card-flush py-4 mt-3 shadow-lg">
                                            <div className="card-header">
                                                <div className="card-title">
                                                    <h2>Price Details</h2>
                                                </div>
                                            </div>
                                            <div className="card-body pt-0">
                                                {Item_flag == 1 ?
                                                    <div class="row g-5 g-xl-8">
                                                        {Tax_details.tax_preference === "Taxable" &&
                                                            <div class="col-xl-4">
                                                                <div class="card card-xl-stretch mb-xl-8">
                                                                    <div class={`card-header border-0 bg-primary py-5`} style={{ minHeight: "40px" }}>
                                                                        <h3 class="card-title fw-bold text-white">Tax Details</h3>
                                                                    </div>

                                                                    <div class="card-body rounded-bottom bg-secondary">
                                                                        {/* <div class="card-rounded bg-body mt-n10 position-relative card-px py-15"> */}
                                                                        <div class="row g-0 mb-7">

                                                                            <div class="col mx-5"><div class={`fs-6 text-primary`}>Tax preference</div><div class="fs-4 fw-bold text-gray-800">{Tax_details.tax_preference}</div></div>
                                                                            <div class="col mx-5"><div class={`fs-6 text-primary`}>Tax Calculation Method</div><div class="fs-4 fw-bold text-gray-800">{Tax_details.tax_calculation_method == "TAX_Inclusive" ? <>Tax Inclusive</> : <>Tax Exclusive</>}</div></div>

                                                                        </div>
                                                                        <div class="row g-0">
                                                                            <div class="col mx-5"><div class={`fs-6 text-primary`}>Intra State Tax Rate</div><div class="fs-4 fw-bold text-gray-800">{Tax_details.tax_details.Intra_State_Tax_name} ({Tax_details.tax_details.Intra_State_Tax_Percentage}%)</div></div>
                                                                            <div class="col mx-5"><div class={`fs-6 text-primary`}>Inter State Tax Rate</div><div class="fs-4 fw-bold text-gray-800">{Tax_details.tax_details.Intra_State_Tax_name} ({Tax_details.tax_details.Intra_State_Tax_Percentage}%)</div></div>
                                                                        </div>
                                                                        {/* </div> */}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        }
                                                        {
                                                            Pricedetails.map((obj, indx) => {
                                                                return (
                                                                    <>
                                                                        <div class="col-xl-4">
                                                                            <div class="card card-xl-stretch mb-xl-8">
                                                                                <div class={`card-header border-0 bg-${obj.color}`} style={{ minHeight: "40px" }}>
                                                                                    {(Tax_details.tax_preference !== "Taxable" && indx == 0) && <h3 class="card-title fw-bold text-white">{Tax_details.tax_preference}</h3>}
                                                                                </div>

                                                                                <div class="card-body rounded-bottom bg-secondary">
                                                                                    {/* <div class="card-rounded bg-body mt-n10 position-relative card-px py-15"> */}
                                                                                    <div class="row g-0 mb-7">
                                                                                        {
                                                                                            obj.price_details.map((obj1, indx1) => {
                                                                                                return (
                                                                                                    <>
                                                                                                        {(indx1 % 2 == 0) && <div class="col mx-5"><div class={`fs-6 text-${obj.color}`}>{obj1.field_name}</div>{(obj1.value !== "" && obj1.value !== null) && <div class="fs-2 fw-bold text-gray-800">{(obj1.type == 'amount') && <>{Currency_symbol}</>}{typeof obj1.value == 'object' ? obj1.value.label : trimDecimalPlaces(obj1.value, Decimal_place)}{(obj1.type == 'percentage') && <>%</>}</div>}</div>}
                                                                                                    </>
                                                                                                )
                                                                                            })
                                                                                        }
                                                                                    </div>
                                                                                    <div class="row g-0">
                                                                                        {
                                                                                            obj.price_details.map((obj1, indx1) => {
                                                                                                return (
                                                                                                    <>
                                                                                                        {(indx1 % 2 !== 0) && <div class="col mx-5"><div class={`fs-6 text-${obj.color}`}>{obj1.field_name}</div>{(obj1.value !== "" && obj1.value !== null) && <div class="fs-2 fw-bold text-gray-800">{(obj1.type == 'amount') && <>{Currency_symbol}</>}{typeof obj1.value == 'object' ? obj1.value.label : trimDecimalPlaces(obj1.value, Decimal_place)}{(obj1.type == 'percentage') && <>%</>}</div>}</div>}
                                                                                                    </>
                                                                                                )
                                                                                            })
                                                                                        }
                                                                                    </div>
                                                                                    {/* </div> */}
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </>
                                                                )
                                                            })
                                                        }
                                                    </div>
                                                    :
                                                    Item_flag == 2 ?
                                                        <img src="/images/loader-06.svg" alt="" style={loaderstyle} />
                                                        :
                                                        Item_flag == 4 &&
                                                        <div className="notice d-flex bg-light-primary rounded border-primary border border-dashed rounded-3 p-6">
                                                            <div className="d-flex flex-stack flex-grow-1">
                                                                <div className="fw-bold">
                                                                    <h4 className="text-gray-800 fw-bolder">No Data Available.</h4>
                                                                    <div className="fs-6 text-gray-600"> </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                }
                                            </div>
                                        </div>
                                    }
                                </>
                                :
                                <>
                                    {
                                        state == 2 ?
                                            <img src="/images/loader-06.svg" alt="" style={loaderstyle} />
                                            :
                                            <>
                                                <div className="card-body pt-0">
                                                    <div className="text-gray-500 fw-bold fs-5 mb-5">Item List</div>
                                                    <div className="notice d-flex bg-light-primary rounded border-primary border border-dashed rounded-3 p-6">
                                                        <div className="d-flex flex-stack flex-grow-1">
                                                            <div className="fw-bold">
                                                                <h4 className="text-gray-800 fw-bolder">No Data Available.</h4>
                                                                <div className="fs-6 text-gray-600"> </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </>
                                    }
                                </>
                        }
                    </div>
                </div>
            </div>
            {toTopButtonDisplay && <button className="btn btn-success rounded-circle py-3 px-4" onClick={() => { window.scrollTo({ top: 0, behavior: 'smooth' }); }} style={{ position: "fixed", right: "10px", bottom: "100px" }} ><i className="fa fa-chevron-up p-0 fs-3"></i></button>}
            <Modal show={StatusModalShow} onHide={() => { setStatusModalShow() }} size="md" centered>
                <Modal.Header>
                    <Modal.Title>Change Status</Modal.Title>
                    <div className="btn btn-sm btn-icon btn-active-color-primary" onClick={() => { setStatusModalShow(false) }}>
                        <span className="svg-icon svg-icon-1">
                            <svg xmlns="http://www.w3.org/2000/svg" xlink="http://www.w3.org/1999/xlink" width="24px" height="24px" viewBox="0 0 24 24" version="1.1">
                                <g transform="translate(12.000000, 12.000000) rotate(-45.000000) translate(-12.000000, -12.000000) translate(4.000000, 4.000000)" fill="#000000">
                                    <rect fill="#000000" x="0" y="7" width="16" height="2" rx="1" />
                                    <rect fill="#000000" opacity="0.5" transform="translate(8.000000, 8.000000) rotate(-270.000000) translate(-8.000000, -8.000000)" x="0" y="7" width="16" height="2" rx="1" />
                                </g>
                            </svg>
                        </span>
                    </div>
                </Modal.Header>
                <Modal.Body>
                    <div className="form-group row">
                        <div className="col-lg-12">
                            Current Status is : {status == "Active" ? <span className="fs-5 fw-bolder text-success"> Active </span> : <span className="fs-5 fw-bolder text-danger"> Deactivated </span>}
                            <h3>Are you sure about changing status?</h3>
                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">Cancel</button>
                    {write == 1 && <form >
                        <button type="button" onClick={(e) => { submitStatus(e) }} className="btn btn-primary" data-kt-indicator={mainSubmitButtonState ? "on" : "off"} disabled={mainSubmitButtonState} ><span className="indicator-label">Update</span>
                            <span className="indicator-progress">Please wait...
                                <span className="spinner-border spinner-border-sm align-middle ms-2"></span></span></button>
                    </form>}
                </Modal.Footer>
            </Modal>

            <Drawer title={Item_name} width={window.innerWidth > 1200 ? 800 : (window.innerWidth - 100)} bodyStyle={{ padding: "1.5rem" }} onClose={onClose} open={open} closeIcon={<a onClick={onClose}>
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48" width="38px" height="38px"><path fill="#f44336" d="M44,24c0,11.045-8.955,20-20,20S4,35.045,4,24S12.955,4,24,4S44,12.955,44,24z" /><path fill="#fff" d="M29.656,15.516l2.828,2.828l-14.14,14.14l-2.828-2.828L29.656,15.516z" /><path fill="#fff" d="M32.484,29.656l-2.828,2.828l-14.14-14.14l2.828-2.828L32.484,29.656z" /></svg>
            </a>}
                extra={
                    <Space>
                        <div className="dropdown">
                            <button className="btn btn-sm btn-secondary rounded" type="button" id="dropdownMenuButton1" data-bs-toggle="dropdown" aria-expanded="false">
                                <i className="fas fa-bars px-0"></i>
                            </button>
                            {write &&
                                <ul className="dropdown-menu" aria-labelledby="dropdownMenuButton1">
                                    <li className="py-1"><Link to={`/edit-item/${productid}`} className="dropdown-item">Edit details</Link></li>
                                    <li className="py-1"><a onClick={(e) => { updateStatus(productid); setStatusModalShow(true); }} className="dropdown-item">Change status</a></li>
                                    <li className="py-1"><Link to={`/item-price-information/${productid}`} className="dropdown-item" >Add/Edit price</Link></li>
                                    {(Item_details.length > 0 && Item_details[0].track_inventory === "1") && <li className="py-1"><Link to={`/item-stock-information/${productid}`} className="dropdown-item">Add/Edit stock</Link></li>}
                                    <li className="py-1"><Link to={`/item-images/${productid}`} className="dropdown-item">Add/Edit product image</Link></li>
                                </ul>
                            }
                        </div>
                    </Space>
                }

            >
                {Item_flag === 1 ?
                    <>
                        <div className="card">
                            <div className="d-flex w-100 overflow-auto">
                                <ul className="nav nav-stretch nav-line-tabs fw-bold fs-6 p-0 p-lg-10 flex-nowrap flex-grow-1">
                                    <li className="nav-item mx-lg-1">
                                        <a className={`nav-link py-3 py-lg-6 text-active-primary ${navtype === "Overview" && "active"}`} onClick={(e) => { setnavtype("Overview"); }}>Overview</a>
                                    </li>
                                    {(Item_details.length > 0 && Item_details[0].tracking_inventory_type !== "None" && Item_details[0].track_inventory === "1") &&
                                        <li className="nav-item mx-lg-1" role="presentation">
                                            <a className={`nav-link py-3 py-lg-6 text-active-primary ${navtype === "Batch_Serial" && "active"}`} onClick={(e) => { setnavtype("Batch_Serial"); }}>{Item_details[0].tracking_inventory_type === "Track Serial Number" ? <>Serial</> : <>Batch</>}</a>
                                        </li>}
                                    <li className="nav-item mx-lg-1" role="presentation">
                                        <a className={`nav-link py-3 py-lg-6 text-active-primary ${navtype === "Transactions" && "active"}`} onClick={(e) => { setnavtype("Transactions"); }}>Transaction</a>
                                    </li>
                                    <li className="nav-item mx-lg-1" role="presentation">
                                        <a className={`nav-link py-3 py-lg-6 text-active-primary ${navtype === "History" && "active"}`} onClick={(e) => { setnavtype("History"); }}>History</a>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <div className="card">
                            {navtype === "Overview" ?
                                <>
                                    <div className="card-header cursor-pointer py-0" style={{ minHeight: "45px" }}>
                                        <div className="card-title m-0">
                                            <h3 className="fw-bold m-0">Overview</h3>
                                        </div>
                                        {/*<a href="/metronic8/demo1/../demo1/account/settings.html" className="btn btn-sm btn-primary align-self-center">Edit Profile</a>*/}
                                    </div>
                                    {Item_details.length > 0 ?
                                        <div className="card-body p-9">
                                            <div className="row mb-7">
                                                <label className="col-lg-4 fw-semibold text-muted">Item Type</label>
                                                <div className="col-lg-8">
                                                    <span className="fw-bold fs-6 text-gray-800">{Item_details[0].product_type}</span>
                                                </div>
                                            </div>
                                            <div className="row mb-7">
                                                <label className="col-lg-4 fw-semibold text-muted">Inventory tracking</label>
                                                <div className="col-lg-8 fv-row">
                                                    <span className="fw-semibold text-gray-800 fs-6">{Item_details[0].tracking_inventory_type}</span>
                                                </div>
                                            </div>
                                            <div className="row mb-7">
                                                <label className="col-lg-4 fw-semibold text-muted">Status
                                                    {/* <i className="fas fa-exclamation-circle ms-1 fs-7" data-bs-toggle="tooltip" aria-label="Phone number must be active" data-bs-original-title="Phone number must be active" data-kt-initialized="1"></i> */}</label>
                                                <div className="col-lg-8 d-flex align-items-center">
                                                    {Item_details[0].add_status == "Active" ?
                                                        <span className="badge badge-success">{Item_details[0].add_status}</span>
                                                        :
                                                        <span className="badge badge-danger">Deactivated</span>
                                                    }
                                                </div>
                                            </div>
                                            <div className="row mb-7">
                                                <label className="col-lg-4 fw-semibold text-muted">Unit</label>
                                                <div className="col-lg-8">
                                                    <a className="fw-semibold fs-6 text-gray-800 text-hover-primary">{UnitSelectionList.filter(option => option.id == Item_details[0].usage_unit)[0].Unit}</a>
                                                </div>
                                            </div>
                                            <div className="row mb-7">
                                                <label className="col-lg-4 fw-semibold text-muted">Tax Preference
                                                    {/* <i className="fas fa-exclamation-circle ms-1 fs-7" data-bs-toggle="tooltip" aria-label="Country of origination" data-bs-original-title="Country of origination" data-kt-initialized="1"></i> */}</label>
                                                <div className="col-lg-8">
                                                    <span className="fw-bold fs-6 text-gray-800">{Tax_details[0].tax_preference}</span>
                                                </div>
                                            </div>
                                            {Tax_details[0].tax_preference === "Taxable" &&
                                                <>
                                                    <div className="row mb-7">
                                                        <label className="col-lg-4 fw-semibold text-muted">Intra State Tax Rate</label>
                                                        <div className="col-lg-8">
                                                            <span className="fw-bold fs-6 text-gray-800">{Tax_details[0].tax_details.Intra_State_Tax} ({Tax_details[0].tax_details.Intra_State_Tax_Percentage}%)</span>
                                                        </div>
                                                    </div>
                                                    <div className="row mb-10">
                                                        <label className="col-lg-4 fw-semibold text-muted">Inter State Tax Rate</label>
                                                        <div className="col-lg-8">
                                                            <span className="fw-semibold fs-6 text-gray-800">{Tax_details[0].tax_details.Inter_State_Tax} ({Tax_details[0].tax_details.Inter_State_Tax_Percentage}%)</span>
                                                        </div>
                                                    </div>
                                                </>
                                            }
                                            <div className="row mb-7">
                                                <label className="col-lg-4 fw-semibold text-muted">Category</label>
                                                <div className="col-lg-8">
                                                    <a className="fw-semibold fs-6 text-gray-800 text-hover-primary">{Item_details[0].category_name}</a>
                                                </div>
                                            </div>
                                            <div className="row mb-7">
                                                <label className="col-lg-4 fw-semibold text-muted">SubCategory
                                                    {/* <i className="fas fa-exclamation-circle ms-1 fs-7" data-bs-toggle="tooltip" aria-label="Country of origination" data-bs-original-title="Country of origination" data-kt-initialized="1"></i> */}</label>
                                                <div className="col-lg-8">
                                                    <span className="fw-bold fs-6 text-gray-800">{Item_details[0].subcategory_name}</span>
                                                </div>
                                            </div>
                                            <div className="row mb-7">
                                                <label className="col-lg-4 fw-semibold text-muted">Brand</label>
                                                <div className="col-lg-8">
                                                    <a className="fw-semibold fs-6 text-gray-800 text-hover-primary">{Item_details[0].brand_name}</a>
                                                </div>
                                            </div>
                                            <div className="row mb-7">
                                                <label className="col-lg-4 fw-semibold text-muted">Manufacturer
                                                    {/* <i className="fas fa-exclamation-circle ms-1 fs-7" data-bs-toggle="tooltip" aria-label="Country of origination" data-bs-original-title="Country of origination" data-kt-initialized="1"></i> */}</label>
                                                <div className="col-lg-8">
                                                    <span className="fw-bold fs-6 text-gray-800">{Item_details[0].manufacturer_display_name}</span>
                                                </div>
                                            </div>
                                            <div className="row mb-7">
                                                <label className="col-lg-4 fw-semibold text-muted">UPC</label>
                                                <div className="col-lg-8">
                                                    <a className="fw-semibold fs-6 text-gray-800 text-hover-primary">{(Item_details[0].Specification_info).UPC}</a>
                                                </div>
                                            </div>
                                            <div className="row mb-7">
                                                <label className="col-lg-4 fw-semibold text-muted">EAN
                                                    {/* <i className="fas fa-exclamation-circle ms-1 fs-7" data-bs-toggle="tooltip" aria-label="Country of origination" data-bs-original-title="Country of origination" data-kt-initialized="1"></i> */}</label>
                                                <div className="col-lg-8">
                                                    <span className="fw-bold fs-6 text-gray-800">{(Item_details[0].Specification_info).EAN}</span>
                                                </div>
                                            </div>
                                            <div className="row mb-7">
                                                <label className="col-lg-4 fw-semibold text-muted">MPN</label>
                                                <div className="col-lg-8">
                                                    <a className="fw-semibold fs-6 text-gray-800 text-hover-primary">{(Item_details[0].Specification_info).MPN}</a>
                                                </div>
                                            </div>
                                            <div className="row mb-7">
                                                <label className="col-lg-4 fw-semibold text-muted">ISBN
                                                    {/* <i className="fas fa-exclamation-circle ms-1 fs-7" data-bs-toggle="tooltip" aria-label="Country of origination" data-bs-original-title="Country of origination" data-kt-initialized="1"></i> */}</label>
                                                <div className="col-lg-8">
                                                    <span className="fw-bold fs-6 text-gray-800">{(Item_details[0].Specification_info).ISBN}</span>
                                                </div>
                                            </div>
                                        </div>
                                        :
                                        <img src="/images/loader-06.svg" alt="" style={loaderstyle} />
                                    }
                                </>
                                :
                                navtype === "Batch_Serial" ?
                                    <>
                                        <div className="card-header cursor-pointer py-0" style={{ minHeight: "45px" }}>
                                            <div className="card-title m-0">
                                                <h3 className="fw-bold">{Item_details[0].tracking_inventory_type === "Track Serial Number" ? <>Serial</> : <>Batch</>} Details</h3>
                                            </div>
                                            {/*<a href="/metronic8/demo1/../demo1/account/settings.html" className="btn btn-sm btn-primary align-self-center">Edit Profile</a>*/}
                                        </div>
                                        {Item_details.length > 0 &&
                                            <>
                                                <div className="card-body p-9">
                                                    <div className="d-flex flex-wrap gap-5">
                                                        <div className="fv-row w-100 flex-md-root">
                                                            <label className="form-label">Branch:</label>
                                                            <Select
                                                                styles={userTheme == 'dark' ? dropdownStyleDark : {}}
                                                                options={Branchlist}
                                                                onChange={(event) => {
                                                                    setBranch_name(event.value);
                                                                    WarehouseLoad(event.value);
                                                                    //Serial_batch_filter(event.value,Warehouse_name);
                                                                }}
                                                                value={Branchlist.filter(option => option.value == Branch_name).length != 0 && Branchlist.filter(option => option.value == Branch_name)[0]}
                                                                placeholder="Select Branch"
                                                            />
                                                        </div>
                                                        <div className="fv-row w-100 flex-md-root">
                                                            <label className="form-label">Warehouse:</label>
                                                            <Select
                                                                styles={userTheme == 'dark' ? dropdownStyleDark : {}}
                                                                options={WarehouseSelectionList}
                                                                onChange={(event) => {
                                                                    setWarehouse_name(event.value);
                                                                    Serial_batch_filter(Branch_name, event.value);
                                                                }}
                                                                value={WarehouseSelectionList.filter(option => option.value == Warehouse_name).length != 0 && WarehouseSelectionList.filter(option => option.value == Warehouse_name)[0]}
                                                                placeholder="Select Warehouse"
                                                            />
                                                        </div>
                                                    </div><br />
                                                    {
                                                        Selected_serial_batch_details.length > 0 ?
                                                            <>
                                                                {Item_details[0].tracking_inventory_type === "Track Batches" && Selected_serial_batch_details.map((obj, index) => {
                                                                    return (
                                                                        <>
                                                                            <div className="d-flex flex-stack">
                                                                                <a onClick={(e) => { showChildrenDrawer(obj.Batch_Reference) }} className="text-primary fw-semibold fs-6 me-2">{obj.Batch_Reference}</a>
                                                                                <button type="button" className="btn btn-icon btn-sm h-auto btn-color-gray-400 btn-active-color-primary justify-content-end">
                                                                                    <span className="svg-icon svg-icon-2">
                                                                                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                                            <path opacity="0.3" d="M4.7 17.3V7.7C4.7 6.59543 5.59543 5.7 6.7 5.7H9.8C10.2694 5.7 10.65 5.31944 10.65 4.85C10.65 4.38056 10.2694 4 9.8 4H5C3.89543 4 3 4.89543 3 6V19C3 20.1046 3.89543 21 5 21H18C19.1046 21 20 20.1046 20 19V14.2C20 13.7306 19.6194 13.35 19.15 13.35C18.6806 13.35 18.3 13.7306 18.3 14.2V17.3C18.3 18.4046 17.4046 19.3 16.3 19.3H6.7C5.59543 19.3 4.7 18.4046 4.7 17.3Z" fill="currentColor"></path>
                                                                                            <rect x="21.9497" y="3.46448" width="13" height="2" rx="1" transform="rotate(135 21.9497 3.46448)" fill="currentColor"></rect>
                                                                                            <path d="M19.8284 4.97161L19.8284 9.93937C19.8284 10.5252 20.3033 11 20.8891 11C21.4749 11 21.9497 10.5252 21.9497 9.93937L21.9497 3.05029C21.9497 2.498 21.502 2.05028 20.9497 2.05028L14.0607 2.05027C13.4749 2.05027 13 2.52514 13 3.11094C13 3.69673 13.4749 4.17161 14.0607 4.17161L19.0284 4.17161C19.4702 4.17161 19.8284 4.52978 19.8284 4.97161Z" fill="currentColor"></path>
                                                                                        </svg>
                                                                                    </span>
                                                                                </button>
                                                                            </div>
                                                                            <div className="separator separator-dashed my-3"></div>
                                                                        </>
                                                                    )
                                                                })}
                                                                {Item_details[0].tracking_inventory_type === "Track Serial Number" &&
                                                                    <>
                                                                        <div className="d-flex align-items-center gap-2 gap-lg-3 flex-wrap">
                                                                            {Selected_serial_batch_details.map((obj, index) => {
                                                                                return (
                                                                                    <>
                                                                                        <div onClick={(e) => { showChildrenDrawer(obj.serialName) }} className="btn btn-sm btn-light d-flex align-items-center">
                                                                                            <div className="text-gray-600 fw-bold">{obj.serialName}</div>
                                                                                        </div>
                                                                                    </>
                                                                                )
                                                                            })}
                                                                        </div>
                                                                    </>
                                                                }
                                                            </>
                                                            :
                                                            <>No data found</>
                                                    }
                                                </div>

                                            </>
                                        }
                                    </>
                                    :
                                    navtype === "Transactions" ?
                                        <>
                                            <div className="card-header cursor-pointer py-0" style={{ minHeight: "45px" }}>
                                                <div className="card-title m-0">
                                                    <h3 className="fw-bold m-0">Transaction Details</h3>
                                                </div>
                                                {/*<a href="/metronic8/demo1/../demo1/account/settings.html" className="btn btn-sm btn-primary align-self-center">Edit Profile</a>*/}
                                            </div>
                                            {Item_details.length > 0 &&
                                                <div className="card-body p-9">

                                                </div>
                                            }
                                        </>
                                        :
                                        navtype === "History" &&
                                        <>
                                            <div className="card-header cursor-pointer py-0" style={{ minHeight: "45px" }}>
                                                <div className="card-title m-0">
                                                    <h3 className="fw-bold m-0">History</h3>
                                                </div>
                                                {/*<a href="/metronic8/demo1/../demo1/account/settings.html" className="btn btn-sm btn-primary align-self-center">Edit Profile</a>*/}
                                            </div>
                                            {Item_details.length > 0 &&
                                                <div className="card-body p-9">
                                                    {Item_history_details.map((obj, index) => {
                                                        return (
                                                            <>
                                                                <div className="m-0">
                                                                    <div className="d-flex align-items-sm-center mb-5">
                                                                        <div className="d-flex align-items-center flex-row-fluid flex-wrap">
                                                                            <div className="flex-grow-1 me-2">
                                                                                {obj.operation === "add" ? <span className="badge badge-lg badge-secondary fw-bold my-2">Created</span> : obj.operation === "update" ? <span className="badge badge-lg badge-primary fw-bold my-2">Updated</span> : (obj.operation === "update_stock" && Math.sign(Number(obj.reference.data.sign)) === 1) ? <><span className="badge badge-lg badge-success fw-bold me-2">Stock In</span><span className="badge badge-lg badge-secondary fw-bold my-2">{obj.reference.data.operation.replace(/(^\w{1})|(\s+\w{1})/g, letter => letter.toUpperCase())}</span></> : (obj.operation === "update_stock" && Math.sign(Number(obj.reference.data.sign)) === -1) ? <><span className="badge badge-lg badge-danger fw-bold me-2">Stock Out</span><span className="badge badge-lg badge-secondary fw-bold my-2">{obj.reference.data.operation.replace(/(^\w{1})|(\s+\w{1})/g, letter => letter.toUpperCase())}</span></> : (obj.operation === "pending_stock" && Math.sign(Number(obj.reference.data.sign)) === 1) ? <><span className="badge badge-lg badge-success fw-bold me-2">Stock In</span><span className="badge badge-lg badge-warning fw-bold my-2">Pending</span></> : (obj.operation === "pending_stock" && Math.sign(Number(obj.reference.data.sign)) === -1) ? <><span className="badge badge-lg badge-danger fw-bold me-2">Stock Out</span><span className="badge badge-lg badge-secondary fw-bold my-2">Pending</span></> : (obj.operation === "cancel_stock" && Math.sign(Number(obj.reference.data.sign)) === 1) ? <><span className="badge badge-lg badge-success fw-bold me-2">Stock In</span><span className="badge badge-lg badge-danger fw-bold my-2">Cancelled</span></> : (obj.operation === "cancel_stock" && Math.sign(Number(obj.reference.data.sign)) === -1) && <><span className="badge badge-lg badge-danger fw-bold me-2">Stock Out</span><span className="badge badge-lg badge-danger fw-bold my-2">Cancelled</span></>}
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                    <div className="timeline">
                                                                        {(obj.operation === "update_stock" && Math.sign(Number(obj.reference.data.sign)) === 1) &&
                                                                            <div className="timeline-item align-items-center mb-7">
                                                                                <div className="timeline-line w-40px mt-6 mb-n12"></div>
                                                                                <span className="svg-icon svg-icon-1 svg-icon-primary me-3 lh-0">
                                                                                    <svg width="24" height="24" mi-view-box="0 0 1024 1024" viewBox="0 0 1024 1024">
                                                                                        <rect fill="white" x="0" y="0" mi-width="1024" mi-height="1024" width="1024" height="1024"></rect>
                                                                                        <g>
                                                                                            <path className="cursor-pointer " ng-repeat="path in icon.paths track by tempIds[$index]" mi-d="M170.667 469.333c0-164.949 133.718-298.667 298.667-298.667s298.667 133.718 298.667 298.667c0 164.949-133.717 298.667-298.667 298.667s-298.667-133.717-298.667-298.667zM469.333 85.333c-212.077 0-384 171.923-384 384 0 212.079 171.923 384 384 384 90.667 0 173.995-31.424 239.689-83.972l156.809 156.809c16.661 16.661 43.678 16.661 60.339 0s16.661-43.678 0-60.339l-156.809-156.809c52.548-65.694 83.972-149.022 83.972-239.689 0-212.077-171.921-384-384-384z" mi-fill="inherit" mi-stroke="inherit" mi-stroke-width="inherit" mi-stroke-linejoin="inherit" mi-stroke-linecap="inherit" mi-stroke-miterlimit="inherit" mi-opacity="1" ng-click="selectPath($index)" mi-absorb-clicks="" d="M170.667 469.333c0-164.949 133.718-298.667 298.667-298.667s298.667 133.718 298.667 298.667c0 164.949-133.717 298.667-298.667 298.667s-298.667-133.717-298.667-298.667zM469.333 85.333c-212.077 0-384 171.923-384 384 0 212.079 171.923 384 384 384 90.667 0 173.995-31.424 239.689-83.972l156.809 156.809c16.661 16.661 43.678 16.661 60.339 0s16.661-43.678 0-60.339l-156.809-156.809c52.548-65.694 83.972-149.022 83.972-239.689 0-212.077-171.921-384-384-384z" fill="inherit" stroke="inherit" stroke-width="inherit" stroke-linejoin="inherit" stroke-linecap="inherit" stroke-miterlimit="inherit" opacity="1">
                                                                                            </path><path className="cursor-pointer " ng-repeat="path in icon.paths track by tempIds[$index]" mi-d="M426.667 597.333c0 23.565 19.102 42.667 42.667 42.667s42.667-19.102 42.667-42.667v-85.333h85.333c23.565 0 42.667-19.102 42.667-42.667s-19.102-42.667-42.667-42.667h-85.333v-85.333c0-23.564-19.102-42.667-42.667-42.667s-42.667 19.103-42.667 42.667v85.333h-85.333c-23.564 0-42.667 19.102-42.667 42.667s19.103 42.667 42.667 42.667h85.333v85.333z" mi-fill="inherit" mi-stroke="inherit" mi-stroke-width="inherit" mi-stroke-linejoin="inherit" mi-stroke-linecap="inherit" mi-stroke-miterlimit="inherit" mi-opacity="1" ng-click="selectPath($index)" mi-absorb-clicks="" d="M426.667 597.333c0 23.565 19.102 42.667 42.667 42.667s42.667-19.102 42.667-42.667v-85.333h85.333c23.565 0 42.667-19.102 42.667-42.667s-19.102-42.667-42.667-42.667h-85.333v-85.333c0-23.564-19.102-42.667-42.667-42.667s-42.667 19.103-42.667 42.667v85.333h-85.333c-23.564 0-42.667 19.102-42.667 42.667s19.103 42.667 42.667 42.667h85.333v85.333z" fill="inherit" stroke="inherit" stroke-width="inherit" stroke-linejoin="inherit" stroke-linecap="inherit" stroke-miterlimit="inherit" opacity="1">
                                                                                            </path>
                                                                                        </g>
                                                                                        <g ng-show="pref.showGrid" className="edit-grid ng-hide">
                                                                                            <g className="hLines"></g>
                                                                                            <g className="vLines"></g>
                                                                                        </g>
                                                                                    </svg>
                                                                                </span>
                                                                                <div className="timeline-content m-0">
                                                                                    <span className="fs-6 text-gray-400 fw-semibold d-block">Stock Added</span>
                                                                                    <span className="fs-6 fw-bold text-gray-800">{Math.abs(obj.reference.data.Quantity_adjust)}</span>
                                                                                </div>
                                                                            </div>}
                                                                        {(obj.operation === "update_stock" && Math.sign(Number(obj.reference.data.sign)) === -1) &&
                                                                            <div className="timeline-item align-items-center mb-7">
                                                                                <div className="timeline-line w-40px mt-6 mb-n12"></div>
                                                                                <span className="svg-icon svg-icon-1 svg-icon-primary me-3 lh-0">
                                                                                    <svg width="24" height="24" mi-view-box="0 0 1024 1024" viewBox="0 0 1024 1024">
                                                                                        <rect fill="white" x="0" y="0" mi-width="1024" mi-height="1024" width="1024" height="1024"></rect>
                                                                                        <g>
                                                                                            <path className="cursor-pointer " ng-repeat="path in icon.paths track by tempIds[$index]" mi-d="M170.667 469.333c0-164.949 133.718-298.667 298.667-298.667s298.667 133.718 298.667 298.667c0 164.949-133.717 298.667-298.667 298.667s-298.667-133.717-298.667-298.667zM469.333 85.333c-212.077 0-384 171.923-384 384 0 212.079 171.923 384 384 384 90.667 0 173.995-31.424 239.689-83.972l156.809 156.809c16.661 16.661 43.678 16.661 60.339 0s16.661-43.678 0-60.339l-156.809-156.809c52.548-65.694 83.972-149.022 83.972-239.689 0-212.077-171.921-384-384-384z" mi-fill="inherit" mi-stroke="inherit" mi-stroke-width="inherit" mi-stroke-linejoin="inherit" mi-stroke-linecap="inherit" mi-stroke-miterlimit="inherit" mi-opacity="1" ng-click="selectPath($index)" mi-absorb-clicks="" d="M170.667 469.333c0-164.949 133.718-298.667 298.667-298.667s298.667 133.718 298.667 298.667c0 164.949-133.717 298.667-298.667 298.667s-298.667-133.717-298.667-298.667zM469.333 85.333c-212.077 0-384 171.923-384 384 0 212.079 171.923 384 384 384 90.667 0 173.995-31.424 239.689-83.972l156.809 156.809c16.661 16.661 43.678 16.661 60.339 0s16.661-43.678 0-60.339l-156.809-156.809c52.548-65.694 83.972-149.022 83.972-239.689 0-212.077-171.921-384-384-384z" fill="inherit" stroke="inherit" stroke-width="inherit" stroke-linejoin="inherit" stroke-linecap="inherit" stroke-miterlimit="inherit" opacity="1">
                                                                                            </path><path className="cursor-pointer " ng-repeat="path in icon.paths track by tempIds[$index]" mi-d="M298.667 469.333c0-23.565 19.103-42.667 42.667-42.667h256c23.565 0 42.667 19.102 42.667 42.667s-19.102 42.667-42.667 42.667h-256c-23.564 0-42.667-19.102-42.667-42.667z" mi-fill="inherit" mi-stroke="inherit" mi-stroke-width="inherit" mi-stroke-linejoin="inherit" mi-stroke-linecap="inherit" mi-stroke-miterlimit="inherit" mi-opacity="1" ng-click="selectPath($index)" mi-absorb-clicks="" d="M298.667 469.333c0-23.565 19.103-42.667 42.667-42.667h256c23.565 0 42.667 19.102 42.667 42.667s-19.102 42.667-42.667 42.667h-256c-23.564 0-42.667-19.102-42.667-42.667z" fill="inherit" stroke="inherit" stroke-width="inherit" stroke-linejoin="inherit" stroke-linecap="inherit" stroke-miterlimit="inherit" opacity="1">
                                                                                            </path>
                                                                                        </g>
                                                                                        <g ng-show="pref.showGrid" className="edit-grid ng-hide">
                                                                                            <g className="hLines"></g>
                                                                                            <g className="vLines"></g>
                                                                                        </g>
                                                                                    </svg>
                                                                                </span>
                                                                                <div className="timeline-content m-0">
                                                                                    <span className="fs-6 text-gray-400 fw-semibold d-block">Stock Removed</span>
                                                                                    <span className="fs-6 fw-bold text-gray-800">{Math.abs(obj.reference.data.Quantity_adjust)}</span>
                                                                                </div>
                                                                            </div>}
                                                                        <div className="timeline-item align-items-center mb-7">
                                                                            <div className="timeline-line w-40px mt-6 mb-n12"></div>
                                                                            <span className="svg-icon svg-icon-1 svg-icon-primary me-3 lh-0"><svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                                <path opacity="0.3" d="M21 22H3C2.4 22 2 21.6 2 21V5C2 4.4 2.4 4 3 4H21C21.6 4 22 4.4 22 5V21C22 21.6 21.6 22 21 22Z" fill="currentColor"></path>
                                                                                <path d="M6 6C5.4 6 5 5.6 5 5V3C5 2.4 5.4 2 6 2C6.6 2 7 2.4 7 3V5C7 5.6 6.6 6 6 6ZM11 5V3C11 2.4 10.6 2 10 2C9.4 2 9 2.4 9 3V5C9 5.6 9.4 6 10 6C10.6 6 11 5.6 11 5ZM15 5V3C15 2.4 14.6 2 14 2C13.4 2 13 2.4 13 3V5C13 5.6 13.4 6 14 6C14.6 6 15 5.6 15 5ZM19 5V3C19 2.4 18.6 2 18 2C17.4 2 17 2.4 17 3V5C17 5.6 17.4 6 18 6C18.6 6 19 5.6 19 5Z" fill="currentColor"></path>
                                                                                <path d="M8.8 13.1C9.2 13.1 9.5 13 9.7 12.8C9.9 12.6 10.1 12.3 10.1 11.9C10.1 11.6 10 11.3 9.8 11.1C9.6 10.9 9.3 10.8 9 10.8C8.8 10.8 8.59999 10.8 8.39999 10.9C8.19999 11 8.1 11.1 8 11.2C7.9 11.3 7.8 11.4 7.7 11.6C7.6 11.8 7.5 11.9 7.5 12.1C7.5 12.2 7.4 12.2 7.3 12.3C7.2 12.4 7.09999 12.4 6.89999 12.4C6.69999 12.4 6.6 12.3 6.5 12.2C6.4 12.1 6.3 11.9 6.3 11.7C6.3 11.5 6.4 11.3 6.5 11.1C6.6 10.9 6.8 10.7 7 10.5C7.2 10.3 7.49999 10.1 7.89999 10C8.29999 9.90003 8.60001 9.80003 9.10001 9.80003C9.50001 9.80003 9.80001 9.90003 10.1 10C10.4 10.1 10.7 10.3 10.9 10.4C11.1 10.5 11.3 10.8 11.4 11.1C11.5 11.4 11.6 11.6 11.6 11.9C11.6 12.3 11.5 12.6 11.3 12.9C11.1 13.2 10.9 13.5 10.6 13.7C10.9 13.9 11.2 14.1 11.4 14.3C11.6 14.5 11.8 14.7 11.9 15C12 15.3 12.1 15.5 12.1 15.8C12.1 16.2 12 16.5 11.9 16.8C11.8 17.1 11.5 17.4 11.3 17.7C11.1 18 10.7 18.2 10.3 18.3C9.9 18.4 9.5 18.5 9 18.5C8.5 18.5 8.1 18.4 7.7 18.2C7.3 18 7 17.8 6.8 17.6C6.6 17.4 6.4 17.1 6.3 16.8C6.2 16.5 6.10001 16.3 6.10001 16.1C6.10001 15.9 6.2 15.7 6.3 15.6C6.4 15.5 6.6 15.4 6.8 15.4C6.9 15.4 7.00001 15.4 7.10001 15.5C7.20001 15.6 7.3 15.6 7.3 15.7C7.5 16.2 7.7 16.6 8 16.9C8.3 17.2 8.6 17.3 9 17.3C9.2 17.3 9.5 17.2 9.7 17.1C9.9 17 10.1 16.8 10.3 16.6C10.5 16.4 10.5 16.1 10.5 15.8C10.5 15.3 10.4 15 10.1 14.7C9.80001 14.4 9.50001 14.3 9.10001 14.3C9.00001 14.3 8.9 14.3 8.7 14.3C8.5 14.3 8.39999 14.3 8.39999 14.3C8.19999 14.3 7.99999 14.2 7.89999 14.1C7.79999 14 7.7 13.8 7.7 13.7C7.7 13.5 7.79999 13.4 7.89999 13.2C7.99999 13 8.2 13 8.5 13H8.8V13.1ZM15.3 17.5V12.2C14.3 13 13.6 13.3 13.3 13.3C13.1 13.3 13 13.2 12.9 13.1C12.8 13 12.7 12.8 12.7 12.6C12.7 12.4 12.8 12.3 12.9 12.2C13 12.1 13.2 12 13.6 11.8C14.1 11.6 14.5 11.3 14.7 11.1C14.9 10.9 15.2 10.6 15.5 10.3C15.8 10 15.9 9.80003 15.9 9.70003C15.9 9.60003 16.1 9.60004 16.3 9.60004C16.5 9.60004 16.7 9.70003 16.8 9.80003C16.9 9.90003 17 10.2 17 10.5V17.2C17 18 16.7 18.4 16.2 18.4C16 18.4 15.8 18.3 15.6 18.2C15.4 18.1 15.3 17.8 15.3 17.5Z" fill="currentColor"></path>
                                                                            </svg>
                                                                            </span>
                                                                            <div className="timeline-content m-0">
                                                                                <span className="fs-6 text-gray-400 fw-semibold d-block">Date</span>
                                                                                <span className="fs-6 fw-bold text-gray-800">{moment(obj.log_date_time).format("lll")} </span>
                                                                            </div>
                                                                        </div>
                                                                        <div className="timeline-item align-items-center">
                                                                            <div className="timeline-line w-40px"></div>
                                                                            <span className="svg-icon svg-icon-1 svg-icon-primary me-3 lh-0"><svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                                <path opacity="0.3" d="M16.5 9C16.5 13.125 13.125 16.5 9 16.5C4.875 16.5 1.5 13.125 1.5 9C1.5 4.875 4.875 1.5 9 1.5C13.125 1.5 16.5 4.875 16.5 9Z" fill="currentColor"></path>
                                                                                <path d="M9 16.5C10.95 16.5 12.75 15.75 14.025 14.55C13.425 12.675 11.4 11.25 9 11.25C6.6 11.25 4.57499 12.675 3.97499 14.55C5.24999 15.75 7.05 16.5 9 16.5Z" fill="currentColor"></path>
                                                                                <rect x="7" y="6" width="4" height="4" rx="2" fill="currentColor"></rect>
                                                                            </svg>
                                                                            </span>
                                                                            <div className="timeline-content m-0">
                                                                                <span className="fs-6 text-gray-400 fw-semibold d-block">User</span>
                                                                                <span className="fs-6 fw-bold text-gray-800">{obj.user_id}</span>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                {Item_history_details.length > 1 &&
                                                                    <div className="separator separator-dashed my-6"></div>
                                                                }
                                                            </>
                                                        )
                                                    })}
                                                </div>
                                            }
                                        </>
                            }
                        </div>
                    </>
                    :
                    Item_flag == 2 ?
                        <div className="card">
                            <img src="/images/loader-06.svg" alt="" style={loaderstyle} />
                        </div>
                        :
                        Item_flag == 0 &&
                        <div className="card">
                            <div class="pt-10 pb-0"><h3 class="text-dark text-center fw-bolder">Authorization error</h3>
                                <div class="text-center text-gray-600 fw-bold pt-1">There have some Authorization error.You need to LogIn further</div><div class="text-center mt-5 mb-9">
                                    <a onClick={(e) => { setRedirect_to_login(1); }}>Log In</a>
                                </div>
                            </div>
                        </div>
                }
                <Drawer
                    title={tag_name}
                    width={window.innerWidth > 1200 ? 440 : (window.innerWidth - 100)}
                    closable={true}
                    onClose={onChildrenDrawerClose}
                    open={childrenDrawer}
                    closeIcon={<a onClick={onChildrenDrawerClose}>
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48" width="38px" height="38px"><path fill="#f44336" d="M44,24c0,11.045-8.955,20-20,20S4,35.045,4,24S12.955,4,24,4S44,12.955,44,24z" /><path fill="#fff" d="M29.656,15.516l2.828,2.828l-14.14,14.14l-2.828-2.828L29.656,15.516z" /><path fill="#fff" d="M32.484,29.656l-2.828,2.828l-14.14-14.14l2.828-2.828L32.484,29.656z" /></svg>
                    </a>}
                >
                    {/*This is two-level drawer*/}
                    {/* <div className="timeline"> */}
                    {Selected_Stock_history_details.map((obj, index) => {
                        return (
                            <>
                                <div className="m-0">
                                    <div className="d-flex align-items-sm-center mb-5">
                                        <div className="d-flex align-items-center flex-row-fluid flex-wrap">
                                            <div className="flex-grow-1 me-2">
                                                {(obj.operation === "Quantity_In" && Math.sign(Number(obj.reference.data.sign)) === 1) ? <><span className="badge badge-lg badge-success fw-bold me-2">Stock In</span><span className="badge badge-lg badge-secondary fw-bold my-2">{obj.reference.data.operation.replace(/(^\w{1})|(\s+\w{1})/g, letter => letter.toUpperCase())}</span></> : (obj.operation === "update_stock" && Math.sign(Number(obj.reference.data.sign)) === -1) && <><span className="badge badge-lg badge-danger fw-bold me-2">Stock Out</span><span className="badge badge-lg badge-secondary fw-bold my-2">{obj.reference.data.operation.replace(/(^\w{1})|(\s+\w{1})/g, letter => letter.toUpperCase())}</span></>}
                                            </div>
                                        </div>
                                    </div>
                                    <div className="timeline">
                                        {(obj.operation === "update_stock" && Math.sign(Number(obj.reference.data.sign)) === 1) &&
                                            <div className="timeline-item align-items-center mb-7">
                                                <div className="timeline-line w-40px mt-6 mb-n12"></div>
                                                <span className="svg-icon svg-icon-1 svg-icon-primary me-3 lh-0">
                                                    <svg width="24" height="24" mi-view-box="0 0 1024 1024" viewBox="0 0 1024 1024">
                                                        <rect fill="white" x="0" y="0" mi-width="1024" mi-height="1024" width="1024" height="1024"></rect>
                                                        <g>
                                                            <path className="cursor-pointer " ng-repeat="path in icon.paths track by tempIds[$index]" mi-d="M170.667 469.333c0-164.949 133.718-298.667 298.667-298.667s298.667 133.718 298.667 298.667c0 164.949-133.717 298.667-298.667 298.667s-298.667-133.717-298.667-298.667zM469.333 85.333c-212.077 0-384 171.923-384 384 0 212.079 171.923 384 384 384 90.667 0 173.995-31.424 239.689-83.972l156.809 156.809c16.661 16.661 43.678 16.661 60.339 0s16.661-43.678 0-60.339l-156.809-156.809c52.548-65.694 83.972-149.022 83.972-239.689 0-212.077-171.921-384-384-384z" mi-fill="inherit" mi-stroke="inherit" mi-stroke-width="inherit" mi-stroke-linejoin="inherit" mi-stroke-linecap="inherit" mi-stroke-miterlimit="inherit" mi-opacity="1" ng-click="selectPath($index)" mi-absorb-clicks="" d="M170.667 469.333c0-164.949 133.718-298.667 298.667-298.667s298.667 133.718 298.667 298.667c0 164.949-133.717 298.667-298.667 298.667s-298.667-133.717-298.667-298.667zM469.333 85.333c-212.077 0-384 171.923-384 384 0 212.079 171.923 384 384 384 90.667 0 173.995-31.424 239.689-83.972l156.809 156.809c16.661 16.661 43.678 16.661 60.339 0s16.661-43.678 0-60.339l-156.809-156.809c52.548-65.694 83.972-149.022 83.972-239.689 0-212.077-171.921-384-384-384z" fill="inherit" stroke="inherit" stroke-width="inherit" stroke-linejoin="inherit" stroke-linecap="inherit" stroke-miterlimit="inherit" opacity="1">
                                                            </path><path className="cursor-pointer " ng-repeat="path in icon.paths track by tempIds[$index]" mi-d="M426.667 597.333c0 23.565 19.102 42.667 42.667 42.667s42.667-19.102 42.667-42.667v-85.333h85.333c23.565 0 42.667-19.102 42.667-42.667s-19.102-42.667-42.667-42.667h-85.333v-85.333c0-23.564-19.102-42.667-42.667-42.667s-42.667 19.103-42.667 42.667v85.333h-85.333c-23.564 0-42.667 19.102-42.667 42.667s19.103 42.667 42.667 42.667h85.333v85.333z" mi-fill="inherit" mi-stroke="inherit" mi-stroke-width="inherit" mi-stroke-linejoin="inherit" mi-stroke-linecap="inherit" mi-stroke-miterlimit="inherit" mi-opacity="1" ng-click="selectPath($index)" mi-absorb-clicks="" d="M426.667 597.333c0 23.565 19.102 42.667 42.667 42.667s42.667-19.102 42.667-42.667v-85.333h85.333c23.565 0 42.667-19.102 42.667-42.667s-19.102-42.667-42.667-42.667h-85.333v-85.333c0-23.564-19.102-42.667-42.667-42.667s-42.667 19.103-42.667 42.667v85.333h-85.333c-23.564 0-42.667 19.102-42.667 42.667s19.103 42.667 42.667 42.667h85.333v85.333z" fill="inherit" stroke="inherit" stroke-width="inherit" stroke-linejoin="inherit" stroke-linecap="inherit" stroke-miterlimit="inherit" opacity="1">
                                                            </path>
                                                        </g>
                                                        <g ng-show="pref.showGrid" className="edit-grid ng-hide">
                                                            <g className="hLines"></g>
                                                            <g className="vLines"></g>
                                                        </g>
                                                    </svg>
                                                </span>
                                                <div className="timeline-content m-0">
                                                    <span className="fs-6 text-gray-400 fw-semibold d-block">Stock Added</span>
                                                    <span className="fs-6 fw-bold text-gray-800">{Math.abs(obj.reference.data.Quantity_adjust)}</span>
                                                </div>
                                            </div>}
                                        {(obj.operation === "update_stock" && Math.sign(Number(obj.reference.data.sign)) === -1) &&
                                            <div className="timeline-item align-items-center mb-7">
                                                <div className="timeline-line w-40px mt-6 mb-n12"></div>
                                                <span className="svg-icon svg-icon-1 svg-icon-primary me-3 lh-0">
                                                    <svg width="24" height="24" mi-view-box="0 0 1024 1024" viewBox="0 0 1024 1024">
                                                        <rect fill="white" x="0" y="0" mi-width="1024" mi-height="1024" width="1024" height="1024"></rect>
                                                        <g>
                                                            <path className="cursor-pointer " ng-repeat="path in icon.paths track by tempIds[$index]" mi-d="M170.667 469.333c0-164.949 133.718-298.667 298.667-298.667s298.667 133.718 298.667 298.667c0 164.949-133.717 298.667-298.667 298.667s-298.667-133.717-298.667-298.667zM469.333 85.333c-212.077 0-384 171.923-384 384 0 212.079 171.923 384 384 384 90.667 0 173.995-31.424 239.689-83.972l156.809 156.809c16.661 16.661 43.678 16.661 60.339 0s16.661-43.678 0-60.339l-156.809-156.809c52.548-65.694 83.972-149.022 83.972-239.689 0-212.077-171.921-384-384-384z" mi-fill="inherit" mi-stroke="inherit" mi-stroke-width="inherit" mi-stroke-linejoin="inherit" mi-stroke-linecap="inherit" mi-stroke-miterlimit="inherit" mi-opacity="1" ng-click="selectPath($index)" mi-absorb-clicks="" d="M170.667 469.333c0-164.949 133.718-298.667 298.667-298.667s298.667 133.718 298.667 298.667c0 164.949-133.717 298.667-298.667 298.667s-298.667-133.717-298.667-298.667zM469.333 85.333c-212.077 0-384 171.923-384 384 0 212.079 171.923 384 384 384 90.667 0 173.995-31.424 239.689-83.972l156.809 156.809c16.661 16.661 43.678 16.661 60.339 0s16.661-43.678 0-60.339l-156.809-156.809c52.548-65.694 83.972-149.022 83.972-239.689 0-212.077-171.921-384-384-384z" fill="inherit" stroke="inherit" stroke-width="inherit" stroke-linejoin="inherit" stroke-linecap="inherit" stroke-miterlimit="inherit" opacity="1">
                                                            </path><path className="cursor-pointer " ng-repeat="path in icon.paths track by tempIds[$index]" mi-d="M298.667 469.333c0-23.565 19.103-42.667 42.667-42.667h256c23.565 0 42.667 19.102 42.667 42.667s-19.102 42.667-42.667 42.667h-256c-23.564 0-42.667-19.102-42.667-42.667z" mi-fill="inherit" mi-stroke="inherit" mi-stroke-width="inherit" mi-stroke-linejoin="inherit" mi-stroke-linecap="inherit" mi-stroke-miterlimit="inherit" mi-opacity="1" ng-click="selectPath($index)" mi-absorb-clicks="" d="M298.667 469.333c0-23.565 19.103-42.667 42.667-42.667h256c23.565 0 42.667 19.102 42.667 42.667s-19.102 42.667-42.667 42.667h-256c-23.564 0-42.667-19.102-42.667-42.667z" fill="inherit" stroke="inherit" stroke-width="inherit" stroke-linejoin="inherit" stroke-linecap="inherit" stroke-miterlimit="inherit" opacity="1">
                                                            </path>
                                                        </g>
                                                        <g ng-show="pref.showGrid" className="edit-grid ng-hide">
                                                            <g className="hLines"></g>
                                                            <g className="vLines"></g>
                                                        </g>
                                                    </svg>
                                                </span>
                                                <div className="timeline-content m-0">
                                                    <span className="fs-6 text-gray-400 fw-semibold d-block">Stock Removed</span>
                                                    <span className="fs-6 fw-bold text-gray-800">{Math.abs(obj.reference.data.Quantity_adjust)}</span>
                                                </div>
                                            </div>}
                                        <div className="timeline-item align-items-center mb-7">
                                            <div className="timeline-line w-40px mt-6 mb-n12"></div>
                                            <span className="svg-icon svg-icon-1 svg-icon-primary me-3 lh-0"><svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path opacity="0.3" d="M21 22H3C2.4 22 2 21.6 2 21V5C2 4.4 2.4 4 3 4H21C21.6 4 22 4.4 22 5V21C22 21.6 21.6 22 21 22Z" fill="currentColor"></path>
                                                <path d="M6 6C5.4 6 5 5.6 5 5V3C5 2.4 5.4 2 6 2C6.6 2 7 2.4 7 3V5C7 5.6 6.6 6 6 6ZM11 5V3C11 2.4 10.6 2 10 2C9.4 2 9 2.4 9 3V5C9 5.6 9.4 6 10 6C10.6 6 11 5.6 11 5ZM15 5V3C15 2.4 14.6 2 14 2C13.4 2 13 2.4 13 3V5C13 5.6 13.4 6 14 6C14.6 6 15 5.6 15 5ZM19 5V3C19 2.4 18.6 2 18 2C17.4 2 17 2.4 17 3V5C17 5.6 17.4 6 18 6C18.6 6 19 5.6 19 5Z" fill="currentColor"></path>
                                                <path d="M8.8 13.1C9.2 13.1 9.5 13 9.7 12.8C9.9 12.6 10.1 12.3 10.1 11.9C10.1 11.6 10 11.3 9.8 11.1C9.6 10.9 9.3 10.8 9 10.8C8.8 10.8 8.59999 10.8 8.39999 10.9C8.19999 11 8.1 11.1 8 11.2C7.9 11.3 7.8 11.4 7.7 11.6C7.6 11.8 7.5 11.9 7.5 12.1C7.5 12.2 7.4 12.2 7.3 12.3C7.2 12.4 7.09999 12.4 6.89999 12.4C6.69999 12.4 6.6 12.3 6.5 12.2C6.4 12.1 6.3 11.9 6.3 11.7C6.3 11.5 6.4 11.3 6.5 11.1C6.6 10.9 6.8 10.7 7 10.5C7.2 10.3 7.49999 10.1 7.89999 10C8.29999 9.90003 8.60001 9.80003 9.10001 9.80003C9.50001 9.80003 9.80001 9.90003 10.1 10C10.4 10.1 10.7 10.3 10.9 10.4C11.1 10.5 11.3 10.8 11.4 11.1C11.5 11.4 11.6 11.6 11.6 11.9C11.6 12.3 11.5 12.6 11.3 12.9C11.1 13.2 10.9 13.5 10.6 13.7C10.9 13.9 11.2 14.1 11.4 14.3C11.6 14.5 11.8 14.7 11.9 15C12 15.3 12.1 15.5 12.1 15.8C12.1 16.2 12 16.5 11.9 16.8C11.8 17.1 11.5 17.4 11.3 17.7C11.1 18 10.7 18.2 10.3 18.3C9.9 18.4 9.5 18.5 9 18.5C8.5 18.5 8.1 18.4 7.7 18.2C7.3 18 7 17.8 6.8 17.6C6.6 17.4 6.4 17.1 6.3 16.8C6.2 16.5 6.10001 16.3 6.10001 16.1C6.10001 15.9 6.2 15.7 6.3 15.6C6.4 15.5 6.6 15.4 6.8 15.4C6.9 15.4 7.00001 15.4 7.10001 15.5C7.20001 15.6 7.3 15.6 7.3 15.7C7.5 16.2 7.7 16.6 8 16.9C8.3 17.2 8.6 17.3 9 17.3C9.2 17.3 9.5 17.2 9.7 17.1C9.9 17 10.1 16.8 10.3 16.6C10.5 16.4 10.5 16.1 10.5 15.8C10.5 15.3 10.4 15 10.1 14.7C9.80001 14.4 9.50001 14.3 9.10001 14.3C9.00001 14.3 8.9 14.3 8.7 14.3C8.5 14.3 8.39999 14.3 8.39999 14.3C8.19999 14.3 7.99999 14.2 7.89999 14.1C7.79999 14 7.7 13.8 7.7 13.7C7.7 13.5 7.79999 13.4 7.89999 13.2C7.99999 13 8.2 13 8.5 13H8.8V13.1ZM15.3 17.5V12.2C14.3 13 13.6 13.3 13.3 13.3C13.1 13.3 13 13.2 12.9 13.1C12.8 13 12.7 12.8 12.7 12.6C12.7 12.4 12.8 12.3 12.9 12.2C13 12.1 13.2 12 13.6 11.8C14.1 11.6 14.5 11.3 14.7 11.1C14.9 10.9 15.2 10.6 15.5 10.3C15.8 10 15.9 9.80003 15.9 9.70003C15.9 9.60003 16.1 9.60004 16.3 9.60004C16.5 9.60004 16.7 9.70003 16.8 9.80003C16.9 9.90003 17 10.2 17 10.5V17.2C17 18 16.7 18.4 16.2 18.4C16 18.4 15.8 18.3 15.6 18.2C15.4 18.1 15.3 17.8 15.3 17.5Z" fill="currentColor"></path>
                                            </svg>
                                            </span>
                                            <div className="timeline-content m-0">
                                                <span className="fs-6 text-gray-400 fw-semibold d-block">Date</span>
                                                <span className="fs-6 fw-bold text-gray-800">{moment(obj.log_date_time).format("lll")} </span>
                                            </div>
                                        </div>
                                        <div className="timeline-item align-items-center">
                                            <div className="timeline-line w-40px"></div>
                                            <span className="svg-icon svg-icon-1 svg-icon-primary me-3 lh-0"><svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path opacity="0.3" d="M16.5 9C16.5 13.125 13.125 16.5 9 16.5C4.875 16.5 1.5 13.125 1.5 9C1.5 4.875 4.875 1.5 9 1.5C13.125 1.5 16.5 4.875 16.5 9Z" fill="currentColor"></path>
                                                <path d="M9 16.5C10.95 16.5 12.75 15.75 14.025 14.55C13.425 12.675 11.4 11.25 9 11.25C6.6 11.25 4.57499 12.675 3.97499 14.55C5.24999 15.75 7.05 16.5 9 16.5Z" fill="currentColor"></path>
                                                <rect x="7" y="6" width="4" height="4" rx="2" fill="currentColor"></rect>
                                            </svg>
                                            </span>
                                            <div className="timeline-content m-0">
                                                <span className="fs-6 text-gray-400 fw-semibold d-block">User</span>
                                                <span className="fs-6 fw-bold text-gray-800">{obj.user_id}</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                {Item_history_details.length > 1 &&
                                    <div className="separator separator-dashed my-6"></div>
                                }
                            </>
                        )
                    })}
                    {/* </div> */}
                </Drawer>
            </Drawer>

            <Modal show={ecommerceModalShow} onHide={() => { handleEcommerceModalClose(); }} centered>
                <Modal.Header>
                    <Modal.Title>Manage E-Commerce Configuration</Modal.Title>
                    <div className="btn btn-sm btn-icon btn-active-color-primary" onClick={() => { handleEcommerceModalClose(); }}>
                        <span className="svg-icon svg-icon-1">
                            <svg xmlns="http://www.w3.org/2000/svg" xlink="http://www.w3.org/1999/xlink" width="24px" height="24px" viewBox="0 0 24 24" version="1.1">
                                <g transform="translate(12.000000, 12.000000) rotate(-45.000000) translate(-12.000000, -12.000000) translate(4.000000, 4.000000)" fill="#000000">
                                    <rect fill="#000000" x="0" y="7" width="16" height="2" rx="1" />
                                    <rect fill="#000000" opacity="0.5" transform="translate(8.000000, 8.000000) rotate(-270.000000) translate(-8.000000, -8.000000)" x="0" y="7" width="16" height="2" rx="1" />
                                </g>
                            </svg>
                        </span>
                    </div>
                </Modal.Header>
                <Modal.Body>
                    {
                        ecommerceProductInfoApiState ? <div className="text-center"><div class="spinner-border text-success" role="status"></div></div> :
                            <div className="container">

                                <div className="row mb-5 gx-0">
                                    <div className="col-6 px-1">
                                        <label className="fs-5 fw-bold mb-2">Business to Business</label>
                                    </div>
                                    <div className="col-6 px-1">
                                        <div className="form-check form-switch form-check-custom form-check-solid">
                                            <input type="checkbox" className="form-check-input" checked={ecommb2b} onChange={(e) => { setEcommb2b(e.target.checked) }} />
                                        </div>
                                    </div>
                                </div>
                                <div className="row mb-5 gx-0">
                                    <div className="col-6 px-1">
                                        <label className="fs-5 fw-bold mb-2">Business to Customer</label>
                                    </div>
                                    <div className="col-6 px-1">
                                        <div className="form-check form-switch form-check-custom form-check-solid">
                                            <input type="checkbox" className="form-check-input" checked={ecommb2c} onChange={(e) => { setEcommb2c(e.target.checked) }} />
                                        </div>
                                    </div>
                                </div>

                            </div>
                    }
                </Modal.Body>
                <Modal.Footer>
                    <button className="btn btn-danger" onClick={() => { handleEcommerceModalClose() }}>Close</button>
                    {
                        write == 1 &&
                        <button type="button" className="btn btn-lg btn-info" data-kt-indicator={ecommerceModalSubmitButtonState ? "on" : "off"} disabled={ecommerceModalSubmitButtonState} onClick={() => { configureProductEcommerceInfoSubmit() }}>
                            <span className="indicator-label">Save</span>
                            <span className="indicator-progress">Please wait...
                                <span className="spinner-border spinner-border-sm align-middle ms-2"></span>
                            </span>
                        </button>
                    }
                </Modal.Footer>
            </Modal>


            <Organization_modal OrganizationModalShow={OrganizationModalShow} setOrganizationModalShow1={setOrganizationModalShow} organization_name={organization_name} organization_list={organization_list} organization_id={organization_id} state_org={state_org} mainSubmitButtonState={mainSubmitButtonState} setMainSubmitButtonState={setMainSubmitButtonState} />
            <Timer_modal clockTimerModalShow={clockTimerModalShow} setClockTimerModalShow1={setClockTimerModalShow} clock_timer={clock_timer} organization_id={organization_id} timer_ref={timer} mainSubmitButtonState={mainSubmitButtonState} setMainSubmitButtonState={setMainSubmitButtonState} />
        </>);

};

export default ItemPriceList;
